<flo-header></flo-header>
<flo-toast-msg></flo-toast-msg>
<flo-message-box></flo-message-box>
<flo-spinner-component></flo-spinner-component>
<div [ngClass]="{'container boxed m-t-2 p-t-1': !isPrintPage }">
    <router-outlet></router-outlet>
</div>